import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "component", "type", "parse", "format", "formatOnBlur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Field } from 'react-final-form';
import { useTheme } from '@mui/material';
import { getObjectWithOnlyProps } from '@helpers';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * FormField component.
 *
 * @author Mikhail Siutsou
 * @function TextFieldForm
 * @category components
 * @return {JSX.Element} textfield form component.
 */
var FormField = function FormField(_ref) {
  var name = _ref.name,
      component = _ref.component,
      type = _ref.type,
      parse = _ref.parse,
      format = _ref.format,
      formatOnBlur = _ref.formatOnBlur,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var FieldComponent = component;
  var theme = useTheme();
  var clearRestProps = getObjectWithOnlyProps(restProps);
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    type: type,
    parse: parse,
    format: format,
    formatOnBlur: formatOnBlur,
    value: restProps.value,
    render: function render(_ref2) {
      var input = _ref2.input,
          _ref2$meta = _ref2.meta,
          error = _ref2$meta.error,
          touched = _ref2$meta.touched;
      var errorField = touched && error;
      var handlers = ['onBlur', 'onFocus', 'onChange'];

      var preparedInput = _objectSpread(_objectSpread({}, input), {}, {
        value: input.value || ''
      });

      var _loop = function _loop() {
        var handler = _handlers[_i];

        if (handler && restProps && restProps[handler]) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          preparedInput[handler] = function (e) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var event; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

            if (e !== null && e !== void 0 && e.target) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              event = e;
            } else {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              event = {
                target: {
                  value: e
                }
              };
            }

            input[handler](event); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument

            restProps[handler](event);
          };
        }
      };

      for (var _i = 0, _handlers = handlers; _i < _handlers.length; _i++) {
        _loop();
      }

      return /*#__PURE__*/_jsx(FieldComponent, _objectSpread(_objectSpread(_objectSpread({
        type: type
      }, clearRestProps), preparedInput), {}, {
        error: errorField // helperText={errorField}
        ,
        theme: theme
      }));
    }
  });
};

export { FormField };